import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from '../utils/logger';

/**
 * ScrollToTop component that scrolls the window to the top whenever
 * the pathname in the URL changes.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top immediately when route changes
    try {
      // Force immediate scroll to top
      window.scrollTo(0, 0);
      
      // Also set these for older browsers
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0; // For Safari
      
      // Use setTimeout to ensure scroll happens after render
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        logger.debug('ScrollToTop: Scrolled to top on route change to:', pathname);
      }, 0);
    } catch (error) {
      logger.error('ScrollToTop: Error scrolling to top:', error);
      
      // Fallback method
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }
  }, [pathname]);

  return null;
}

export default ScrollToTop;
